import axios from "axios";
import store from "@/store/index";
// 创建 axios 实例
let service = axios.create({
  headers: { "Content-Type": "application/json" },
  timeout: 60000
});

// 设置 post、put 默认 Content-Type
// service.defaults.headers.post['Content-Type'] = 'application/json'
// service.defaults.headers.put['Content-Type'] = 'application/json'

// 添加请求拦截器
service.interceptors.request.use(
  config => {
    if (config.method === "post") {
      config.timeout = 600 * 1000;
      return config;
    }
    // console.log("post", config);
    if (config.url.indexOf("/webservice") !== -1) {
      config.params = {
        ...config.params,
        wstoken: store.state.auth.userinfo.wstoken,
        moodlewsrestformat: "json"
      };
    }
    // 请求发送前进行处理
    // console.log('config', config)
    return config;
  },
  error => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    let { data } = response;
    // console.log("data", data);
    if (data.errorcode) {
      let info = {
        code: data.errorcode,
        data: data,
        msg: data.error || data.message
      };
      return Promise.reject(info);
    }
    return data;
  },
  error => {
    console.log("错误捕获", error);
    let info = {};
    if (!error.response) {
      info = {
        code: 5,
        msg: "网络有点慢，建议您稍后再来尝试！"
      };
    } else {
      let { status, statusText, data } = error.response;
      // 此处整理错误信息格式
      info = {
        code: status,
        data: data,
        msg: statusText
      };
    }
    // 请求错误处理
    return Promise.reject(info);
  }
);

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function () {
  return service;
}
